import { useState, useEffect } from 'react';
import { db } from '../firebase/firebaseConfig';
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

const useObtenerVentas = (date) => {
  const [ordenes, setOrdenes] = useState([]);

  const UnixDate = Number(date.setHours(0, 0, 0, 0));

  useEffect(() => {
    const consulta = query(
      collection(db, 'ordenes'),
      where('fechaUnix', '>=', UnixDate),
      where('estado', '==', 'entregado'),
      orderBy('fechaUnix', 'asc')
    );

    const unsub = onSnapshot(consulta, (snapshot) => {
      const dataSnapShot = snapshot.docs.map((orden) => {
        return {
          idOrden: orden.id,
          cliente: orden.data().cliente,
          descuento: orden.data().descuento,
          fecha: orden.data().fecha,
          formaDePago: orden.data().formDePago,
          productos: orden.data().productos,
          RangoHorario: orden.data().rangoHorario,
          subtotal: orden.data().subTotal,
          total: orden.data().total,
          estado: orden.data().estado,
          fechaOrden: new Date(orden.data().fechaUnix),
        };
      });
      setOrdenes(dataSnapShot);
    });

    return unsub;
  }, [UnixDate]);
  return [ordenes];
};

export default useObtenerVentas;
